export default __webpack_public_path__ + "static/media/distribuicao-varietal.39121d4a.svg";